// src/i18n/index.js
import { createI18n } from 'vue-i18n'
import zh from '@/i18n/locale/zh.js'
import en from '@/i18n/locale/en.js'
// 越南语暂时下线，语言包文件保留以便后续恢复
// import yue from '@/i18n/locale/yue.js'
import zhtw from '@/i18n/locale/zhtw.js'

const savedRaw = localStorage.getItem('app-language')
// 历史存储的 yue 回退为中文
const savedLang = savedRaw === 'yue' ? 'zh' : savedRaw

// 初始化默认语言：本地存储 > 浏览器语言 > 中文
const defaultLocale = savedLang
  ? savedLang
  : (['zh', 'en', 'zhtw'].includes(navigator.language.split('-')[0])
    ? navigator.language.split('-')[0]
    : 'zh')
console.log(defaultLocale, 'defaultLocale');
const i18n = createI18n({
  locale: defaultLocale, // 默认语言（支持持久化）
  legacy: false, // 启用 Vue3 模式（必须）
  fallbackLocale: 'en', // 降级语言
  messages: {
    zh, en, zhtw // 越南语（yue）暂时下线
  }, // 多语言消息
  globalInjection: true // 关键：启用全局注入，支持 this.$t 和 this.$i18n
})

export default i18n